import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import api from "@/lib/api";
import { BadgeCheck, XCircle } from "lucide-react";

export default function VerifyCertificate() {
  const { certId } = useParams();
  const [c, setC] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/public/certificates/${certId}`).then((r) => setC(r.data)).catch(() => setErr(true)); }, [certId]);
  return (
    <div className="min-h-screen flex flex-col bg-soft-gray">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="bg-white rounded-xl border border-navy/10 shadow-lg p-8 max-w-lg w-full text-center" data-testid="verify-card">
          {err ? <><XCircle className="mx-auto text-red-500" size={48} /><h1 className="font-display text-2xl font-black text-navy mt-3">Certificate not found</h1><p className="text-sm text-dark-text/60 mt-2">Credential ID {certId} could not be verified.</p></>
            : !c ? <p className="animate-pulse">Verifying…</p> : (
              <>
                <BadgeCheck className="mx-auto text-emerald-600" size={48} />
                <p className="text-xs uppercase tracking-[0.2em] text-magenta font-bold mt-3">Verified credential</p>
                <h1 className="font-display text-3xl font-black text-navy mt-2" data-testid="verify-name">{c.name}</h1>
                <p className="text-sm text-dark-text/70 mt-2">completed</p>
                {c.programs.map((p) => <p key={p} className="font-bold text-navy">{p}</p>)}
                <p className="text-xs text-dark-text/50 mt-4">Issued {c.issue_date} by {c.issuer} · ID {c.cert_id}</p>
              </>
            )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
